import { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import axiosInstance from '../services/axiosService';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get('/api/orders?status=1,2,3');
      setOrders(response.data.data || []);
    } catch (error) {
      console.error('Error fetching orders:', error);
      toast.error('Không thể tải danh sách đơn hàng. Vui lòng thử lại sau.');
    } finally {
      setLoading(false);
    }
  };

  const getStatusBg = (status) => {
    if (status === 1) return 'bg-yellow-100';
    if (status === 2) return 'bg-white';
    if (status === 3) return 'bg-green-100';
    return 'bg-gray-100';
  };

  const renderProducts = (products) => {
    if (!Array.isArray(products)) return null;
    return products.map((p, idx) => (
      <span key={idx} className="block mr-2 font-bold text-xl">
        {p.name} {p.size ?? ''} x{p.quantity}
      </span>
    ));
  };

  const handleUpdateOrderStatus = async (order, newStatus = null) => {
    try {
      const _newStatus = newStatus ?? Number(order.status) + 1;
      await axiosInstance.put("/api/orders", {
        id: order.id,
        status: _newStatus,
      });
      toast.success('Cập nhật trạng thái thành công!');
      fetchOrders();
    } catch (err) {
      toast.error('Cập nhật trạng thái thất bại!');
    }
  };

  return (
    <Layout maxWidthClass="max-w-full">
      <div className="bg-white shadow rounded-lg">
        
        {loading ? (
          <div className="text-center py-10">
            <div className="spinner"></div>
            <p className="mt-2 text-gray-500">Đang tải dữ liệu...</p>
          </div>
        ) : orders.length === 0 ? (
          <div className="text-center py-10">
            <p className="text-gray-500">Không có đơn hàng nào.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 p-4">
            {orders.map((order) => (
              <div
                key={order.id}
                className={`relative rounded-lg shadow p-5 border ${getStatusBg(Number(order.status))} flex flex-col items-center text-center`}
              >
                <button
                  className="absolute top-0 right-2 text-red-500 hover:text-red-700 font-bold text-lg"
                  title="Hủy đơn hàng"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (window.confirm("Bạn có chắc chắn muốn hủy đơn hàng này không?")) {
                      handleUpdateOrderStatus(order, 5);
                    }
                  }}
                >
                  x
                </button>
                {(!order.location && !order.distance) && (
                  <div className="absolute top-0 left-2 bg-red-500 text-white px-2 py-1 rounded-b text-sm">
                    Online
                  </div>
                )}
                <div className="flex justify-center items-center mb-2 w-full">
                  <span
                    className="font-bold text-2xl text-green-500 mb-5 cursor-pointer hover:underline"
                    onClick={() => handleUpdateOrderStatus(order)}
                    title="Click để cập nhật trạng thái đơn hàng"
                  >
                    {order.order_code || `#${order.id}`}
                  </span>
                </div>
                <div className="mb-1 text-gray-700 w-full mb-5">
                  {renderProducts(order.products)}
                </div>
                <div className="mb-3 w-full text-xl font-bold text-red-600">
                  {new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(order.total_amount)}
                </div>
                <div className="mb-1 w-full text-blue-700 font-semibold">{order.note}</div>
                <div className="mb-1 w-full text-purple-700 italic mb-5">{order.note_system}</div>
                <div className="mb-1 w-full text-orange-600 font-bold">{order.address_note}</div>
                <div className="text-sm w-full flex justify-center">
                  <a
                    href={order.address_map}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline font-semibold"
                  >
                    Xem trên map
                  </a>
                </div>
                {(!order.location && !order.distance) && (
                  <button 
                    className="mt-3 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg font-semibold"
                    onClick={() => navigate('/create-order', { state: { order } })}
                  >
                    Tạo đơn
                  </button>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Orders; 